export const ArticleTypeEnum = Object.freeze({
    SERVICE_CARD_SERVICE: 'SERVICE_CARD_SERVICE',
    SERVICE_CARD_ISSUE_HANDLE: 'SERVICE_CARD_ISSUE_HANDLE',
    WWW_ARTICLE: 'WWW_ARTICLE',
});
